import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {StatusModalStates} from 'components/StatusModal';
import {
  CloseButton,
  ErrorMessage,
  ModalBody,
  ModalHeader,
  ModalSubtitle,
  ModalTitleText,
  Row,
  StyledModalGuestRegistered,
} from './styled';

type Props = {
  onClose: () => void;
  title: string;
  state?: StatusModalStates;
  errorMessage?: string;
  errorMessages?: string[];
  successSubtitle?: string | ReactNode;
};
export function GuestsProcessingModal({
  title,
  state,
  successSubtitle,
  errorMessage,
  errorMessages,
  onClose,
}: Props) {
  const {t} = useTranslation();

  return (
    <StyledModalGuestRegistered>
      {state !== StatusModalStates.IDLE && (
        <ModalHeader>
          <Row className="modalTitle">
            <ModalTitleText>{title}</ModalTitleText>
          </Row>
        </ModalHeader>
      )}
      <ModalBody>
        <Row>
          <ModalSubtitle>
            {state === StatusModalStates.LOADING && t('it_could_take_seconds')}
            {state === StatusModalStates.SUCCESS && successSubtitle}
            {state === StatusModalStates.ERROR && (
              <>
                {errorMessages && errorMessages.length > 0 ? (
                  errorMessages.map((message, index) => (
                    <ErrorMessage key={index} style={{marginBottom: '8px'}}>
                      {message}
                    </ErrorMessage>
                  ))
                ) : (
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                )}
                <CloseButton width={195} primary label={t('ok')} onClick={onClose} />
              </>
            )}
          </ModalSubtitle>
        </Row>
      </ModalBody>
    </StyledModalGuestRegistered>
  );
}
